import { render, staticRenderFns } from "./classSchedule.vue?vue&type=template&id=a6e9c038&scoped=true&class=m-0"
import script from "./classSchedule.vue?vue&type=script&lang=js"
export * from "./classSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e9c038",
  null
  
)

export default component.exports